const SoftwareCompanyTeam = () => {
  return (
    <>
      <section className="sc-team-section ptb-120 bg-white position-relative z-1 overflow-hidden border-line-bg">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6">
              <div className="section-title text-center">
                <h2 className="mb-40">
                  Meet our experts the trust
                  <br className="d-none d-lg-block" /> from clients
                </h2>
              </div>
            </div>
          </div>
          <div className="sc-team-filter">
            <div className="text-center">
              <ul className="nav nav-tabs border-0 d-inline-flex sc-team-filter-nav rounded justify-content-center">
                <li>
                  <a href="#founder" data-bs-toggle="tab" className="active">
                    <span className="me-2">
                      <svg
                        width="20"
                        height="22"
                        viewBox="0 0 20 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.9256 10.3444C12.0194 9.97388 12.0154 9.58529 11.9139 9.21674C11.8124 8.8482 11.617 8.51233 11.3467 8.24203C11.0764 7.97173 10.7405 7.77626 10.372 7.67478C10.0034 7.5733 9.61483 7.56927 9.24426 7.6631C8.47387 7.8532 7.84356 8.48352 7.65346 9.2539C7.55963 9.62447 7.56365 10.0131 7.66514 10.3816C7.76662 10.7501 7.96208 11.086 8.23238 11.3563C8.50268 11.6266 8.83855 11.8221 9.2071 11.9236C9.57565 12.025 9.96423 12.0291 10.3348 11.9352C11.1152 11.7451 11.7455 11.1148 11.9256 10.3444Z"
                          stroke="#666666"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M15.8074 16.1976C16.6864 15.3789 17.387 14.3877 17.8656 13.2859C18.3441 12.1842 18.5903 10.9956 18.5888 9.7944C18.5888 8.6395 18.3613 7.49591 17.9194 6.42893C17.4774 5.36194 16.8296 4.39245 16.013 3.57582C15.1963 2.75918 14.2269 2.11139 13.1599 1.66943C12.0929 1.22747 10.9493 1 9.7944 1C8.6395 1 7.49591 1.22747 6.42893 1.66943C5.36194 2.11139 4.39245 2.75918 3.57582 3.57582C2.75918 4.39245 2.11139 5.36194 1.66943 6.42893C1.22747 7.49591 1 8.6395 1 9.7944C1 12.3357 2.08054 14.6268 3.81141 16.2276"
                          stroke="#666666"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M5.79201 13.5561C4.87155 12.5757 4.30127 11.255 4.30127 9.79426C4.30127 6.76274 6.7625 4.30151 9.79402 4.30151C12.8255 4.30151 15.2868 6.76274 15.2868 9.79426C15.2868 11.255 14.7165 12.5656 13.796 13.5561M8.09317 15.6672L6.65244 17.4581C5.51187 18.8888 6.52238 20.9999 8.3533 20.9999H11.2247C13.0556 20.9999 14.0762 18.8788 12.9256 17.4581L11.4849 15.6672C10.6244 14.5767 8.9636 14.5767 8.09317 15.6672V15.6672Z"
                          stroke="#666666"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    Founders
                  </a>
                </li>
                <li>
                  <a href="#developers" data-bs-toggle="tab">
                    <span className="me-2">
                      <svg
                        width="21"
                        height="22"
                        viewBox="0 0 21 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5989 1.90127L17.4989 4.52127C19.1989 5.27127 19.1989 6.51127 17.4989 7.26127L11.5989 9.88127C10.9289 10.1813 9.82889 10.1813 9.15889 9.88127L3.25889 7.26127C1.55889 6.51127 1.55889 5.27127 3.25889 4.52127L9.15889 1.90127C9.82889 1.60127 10.9289 1.60127 11.5989 1.90127V1.90127Z"
                          stroke="#666666"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1.58887 9.98132C1.58887 10.8213 2.21887 11.7913 2.98887 12.1313L9.77887 15.1513C10.2989 15.3813 10.8889 15.3813 11.3989 15.1513L18.1889 12.1313C18.9589 11.7913 19.5889 10.8213 19.5889 9.98132"
                          stroke="#666666"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1.58887 14.9813C1.58887 15.9113 2.13887 16.7513 2.98887 17.1313L9.77887 20.1513C10.2989 20.3813 10.8889 20.3813 11.3989 20.1513L18.1889 17.1313C19.0389 16.7513 19.5889 15.9113 19.5889 14.9813"
                          stroke="#666666"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    Developers
                  </a>
                </li>
                <li>
                  <a href="#designers" data-bs-toggle="tab">
                    <span className="me-2">
                      <svg
                        width="19"
                        height="22"
                        viewBox="0 0 19 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.5972 17.8168L13.0389 16.3447C13.8472 15.5226 13.8805 14.9491 13.2389 14.0219L10.6972 10.3225C10.1639 9.54821 9.28887 9.54821 8.75553 10.3225L6.21387 14.0219C5.5722 14.9491 5.5722 15.5513 6.41387 16.3447L7.85553 17.8168M9.7222 10.1218V12.5402M15.1639 9.14673L10.7472 4.08042M4.26387 9.14673L8.68053 4.08042M8.6722 21H10.7722C11.5722 21 12.0889 20.35 11.9389 19.5566L11.5972 17.8264H7.8472L7.50553 19.5566C7.35553 20.3022 7.9222 21 8.6722 21ZM9.00553 4.45322L8.35553 3.70761C7.96387 3.25833 7.96387 2.53184 8.35553 2.08257L9.00553 1.33696C9.3972 0.887681 10.0305 0.887681 10.4222 1.33696L11.0722 2.08257C11.4639 2.53184 11.4639 3.25833 11.0722 3.70761L10.4222 4.45322C10.0305 4.9025 9.3972 4.9025 9.00553 4.45322ZM15.9222 8.86952H16.8389C17.3889 8.86952 17.8389 9.38571 17.8389 10.0166V11.0681C17.8389 11.699 17.3889 12.2152 16.8389 12.2152H15.9222C15.3722 12.2152 14.9222 11.699 14.9222 11.0681V10.0166C14.9222 9.38571 15.3722 8.86952 15.9222 8.86952ZM3.50553 8.86952H2.58887C2.03887 8.86952 1.58887 9.38571 1.58887 10.0166V11.0681C1.58887 11.699 2.03887 12.2152 2.58887 12.2152H3.50553C4.05553 12.2152 4.50553 11.699 4.50553 11.0681V10.0166C4.50553 9.38571 4.05553 8.86952 3.50553 8.86952V8.86952Z"
                          stroke="#666666"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    Designers
                  </a>
                </li>
                <li>
                  <a href="#marketers" data-bs-toggle="tab">
                    <span className="me-2">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.838867 21H20.8389"
                          stroke="#666666"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M8.58887 3V21H13.0889V3C13.0889 1.9 12.6389 1 11.2889 1H10.3889C9.03887 1 8.58887 1.9 8.58887 3V3ZM1.83887 9V21H5.83887V9C5.83887 7.9 5.43887 7 4.23887 7H3.43887C2.23887 7 1.83887 7.9 1.83887 9ZM15.8389 14V21H19.8389V14C19.8389 12.9 19.4389 12 18.2389 12H17.4389C16.2389 12 15.8389 12.9 15.8389 14V14Z"
                          stroke="#666666"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    Marketers
                  </a>
                </li>
                <li>
                  <a href="#writers" data-bs-toggle="tab">
                    <span className="me-2">
                      <svg
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.42236 9.99999V8.76666C8.42236 7.17499 9.54736 6.53333 10.9224 7.32499L11.989 7.94166L13.0557 8.55833C14.4307 9.34999 14.4307 10.65 13.0557 11.4417L11.989 12.0583L10.9224 12.675C9.54736 13.4667 8.42236 12.8167 8.42236 11.2333V9.99999Z"
                          stroke="#666666"
                          strokeWidth="1.5"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M10.8387 18.3333C15.4412 18.3333 19.172 14.6025 19.172 9.99996C19.172 5.39746 15.4412 1.66663 10.8387 1.66663C6.2362 1.66663 2.50537 5.39746 2.50537 9.99996C2.50537 14.6025 6.2362 18.3333 10.8387 18.3333Z"
                          stroke="#666666"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    Content Creator
                  </a>
                </li>
              </ul>
              <div className="tab-content mt-5">
                <div className="tab-pane fade show active" id="founder">
                  <div className="row g-4">
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-1.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Forrest Collman</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-2.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Joseph Martin</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-3.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Retha Battle</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-4.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Gerard L. Small</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="developers">
                  <div className="row g-4">
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-1.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Forrest Collman</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-2.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Joseph Martin</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-3.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Retha Battle-2</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-4.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Gerard L. Small</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="designers">
                  <div className="row g-4">
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-1.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Forrest Collman</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-2.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Joseph Martin</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-3.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Retha Battle</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-4.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Gerard L. Small</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="marketers">
                  <div className="row g-4">
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-1.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Forrest Collman</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-2.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Joseph Martin</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-3.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Retha Battle</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-4.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Gerard L. Small</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="writers">
                  <div className="row g-4">
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-1.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Forrest Collman</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-2.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Joseph Martin</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-3.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Retha Battle</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-sm-6">
                      <div className="sc-team-card bg-white rounded text-center rounded">
                        <div className="thumbnail d-inline-block position-relative z-1">
                          <img
                            src="assets/img/software-company/team-4.png"
                            alt="not found"
                            className="img-fluid"
                          />
                          <img
                            src="assets/img/software-company/team-shape.png"
                            alt="not found"
                            className="position-absolute z--1 thumb-shape"
                          />
                        </div>
                        <h5 className="mt-4 mb-2">Gerard L. Small</h5>
                        <span className="d-inline-block mb-4 text-dg-color fs-sm">
                          WordPress Developer
                        </span>
                        <div className="sc-team-social d-flex justify-content-center align-items-center flex-wrap">
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                          <a href="#">
                            <i className="fab fa-twitter"></i>
                          </a>
                          <a href="#">
                            <i className="fa-brands fa-github"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SoftwareCompanyTeam;
